import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"label":_vm.label,"items":_vm.langAvailable,"item-value":"lang"},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})
}
var staticRenderFns = []

export { render, staticRenderFns }